import React from 'react'
import Button, { IconButton } from './Button'

export type DialogAction = {
  label: string
  onClick: () => void
}

export default function Dialog({
  onClose,
  title,
  children,
  action,
  open,
}: {
  onClose: () => void
  title: string
  children: React.ReactNode
  action: DialogAction
  open: boolean
}): React.ReactNode {
  const ref = React.useRef<HTMLDialogElement>(null)

  function handleClose() {
    onClose()

    if (!ref.current) return

    ref.current.close()
  }

  function handleAction() {
    action.onClick()

    if (!ref.current) return

    ref.current.close()
  }

  React.useEffect(() => {
    if (!ref.current) return

    if (open) {
      ref.current.showModal()
    } else {
      onClose()
    }
  })

  return (
    <dialog className="appearance-none h-dvh w-dvw max-h-[100dvh] max-w-[100dvw]" ref={ref} autoFocus>
      <nav className="bg-brand w-full flex items-center gap-2 h-[58px] px-4 text-white">
        <IconButton onClick={handleClose} icon="closeWhite" />
        <h2>
          {title}
        </h2>
      </nav>
      <div className="h-[calc(100dvh-116px)] overflow-scroll bg-white">
        {children}
      </div>
      <div className="flex justify-center items-center h-[58px] bg-white">
        <Button onClick={handleAction}>
          {action.label}
        </Button>
      </div>
    </dialog>
  )
}
